'use client'

import { Button } from '@radix-ui/themes'
import { ComponentPropsWithoutRef } from 'react'

type ConfirmButtonProps = ComponentPropsWithoutRef<typeof Button> & {
    loading?: boolean
}

/**
 * Standardized confirm/submit button component
 * Always uses cyan color for consistency across the application
 */
export const ConfirmButton = ({
    children,
    type = 'button',
    color = 'cyan',
    loading = false,
    disabled,
    ...props
}: ConfirmButtonProps) => {
    return (
        <Button
            color={color}
            type={type}
            disabled={disabled || loading}
            {...props}
        >
            {children}
        </Button>
    )
}
